import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { array, bool, object } from 'prop-types'
import Media from 'react-media'
// Import Components
import { RelatedContentCards } from '../RelatedContentCards'
import { SponsorDetails } from '../SponsorDetails'
import { AdsenseContext } from '../AdsenseProvider'

// Styled Components
const RailContainer = styled.div`
	display: block;
	height: auto;
`

const AdContainer = styled.div`
	display: block;
	min-width: 300px;
	margin: auto;
	margin-bottom: 1.25rem;
	min-height: 250px;
	text-align: center;
	width: 300px;

	${({ theme }) => theme.MQ.M} {
		margin-bottom: 15px;
	}
`

const AdvertorialAdRightRailContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	justify-content: space-around;
	width: 100%;
`

RelatedRail.propTypes = {
	category: object.isRequired,
	hasAdsense: bool,
	isSingleSponsorOrAdvertorial: bool,
	relatedBestPicks: array,
	relatedArticles: array,
	relatedExperts: array,
	relatedReviews: array,
	relatedSponsoredArticles: array,
	sponsorship: object,
}

/**
 * This is the Related Rail component
 * Displays an ad if dfp is true
 * Will display related Articles, Reviews, Experts and Advice if the content is given
 */
export function RelatedRail({
	category,
	isSingleSponsorOrAdvertorial,
	relatedBestPicks,
	relatedArticles,
	relatedExperts,
	relatedReviews,
	relatedSponsoredArticles,
	sponsorship,
}) {
	const { adsenseMediaQuery, hasAdsense } = useContext(AdsenseContext)

	// Single-Sponsor and Advertorial looks the same on right rail just with different sponsor data.
	if (isSingleSponsorOrAdvertorial) {
		return (
			<AdvertorialAdRightRailContainer id="related-rail-wrapper">
				<AdContainer id="adunit-atf" />
				<SponsorDetails {...sponsorship} />
				{relatedSponsoredArticles && relatedSponsoredArticles.length > 0 && (
					<RelatedContentCards
						sponsorship={sponsorship}
						relatedSponsoredArticles={relatedSponsoredArticles}
						seeMoreLink={`/${category.sub.slug}/#productsandservices`}
					/>
				)}
			</AdvertorialAdRightRailContainer>
		)
	}
	return (
		<>
			<RailContainer id="related-rail-wrapper">
				{/* Keep defaultMatches false. SSR was causing issues with the right rail display, assume this is being rendered mobile first */}
				<Media query={adsenseMediaQuery}>
					{(matches) =>
						(matches || sponsorship?.sponsorType === 'hub-sponsor') && hasAdsense ? (
							<AdContainer id="adunit-atf" />
						) : null
					}
				</Media>

				{
					/* Best Picks Related Cards*/
					relatedBestPicks && relatedBestPicks.length > 0 && (
						<RelatedContentCards
							bestPicks={relatedBestPicks}
							contentType="Best Picks"
							seeMoreLink={`/${category.primary.slug}/#productsandservices`}
						/>
					)
				}
				{
					/* Article Related Cards */
					relatedArticles && relatedArticles.length > 0 && (
						<RelatedContentCards
							articles={relatedArticles}
							contentType="Articles"
							seeMoreLink={`/${category.primary.slug}/`}
						/>
					)
				}
				{
					/* Review Related Cards */
					relatedReviews && relatedReviews.length > 0 && (
						<RelatedContentCards
							contentType="Reviews"
							seeMoreLink={`/${category.primary.slug}/#productsandservices`}
							reviews={relatedReviews}
						/>
					)
				}
				{
					/* Expert Related Cards */
					relatedExperts && relatedExperts.length > 0 && (
						<RelatedContentCards
							contentType="Experts"
							experts={relatedExperts}
							seeMoreLink="/advice/service_provider"
						/>
					)
				}
			</RailContainer>
		</>
	)
}
